export default __webpack_public_path__ + "static/media/cindy.7b3e9d80.jpg";